/**
 *
 * Simple reusable confirmation modal dialog.
 * Returns true or false.
 *
 */
import React from 'react';
import { Button } from 'primereact/button';
import PlaylistDialog from './PlaylistPage/PlaylistDialog';
import '../pages/PlaylistPage/PlaylistPage.css';

const DESTRUCTIVE_LABEL = /delete|remove/i;

export const ConfirmDialog = ({ isOpen, handleClose, props }) => {
  const { title, subtitle, noLabel, yesLabel, handleConfirm, data, icon } = props;

  const DialogFooter = (
    <>
      <Button
        label={noLabel}
        icon="pi pi-times"
        className="p-button-text"
        onClick={() => handleConfirm(false, data)}
      />
      <Button label={yesLabel} onClick={() => handleConfirm(true, data)} />
    </>
  );

  return (
    <>
      {isOpen && (
        <PlaylistDialog
          visible={isOpen}
          style={{ width: '440px' }}
          breakpoints={{ '520px': 'calc(100vw - 24px)' }}
          title={title}
          kicker="Confirmation"
          icon={
            icon ||
            (DESTRUCTIVE_LABEL.test(yesLabel || '') ? 'pi pi-trash' : 'pi pi-question-circle')
          }
          className="p-fluid"
          footer={DialogFooter}
          onHide={() => handleClose()}
        >
          <p className="playlist-dialog-intro" style={{ margin: 0 }}>
            {subtitle}
          </p>
        </PlaylistDialog>
      )}
    </>
  );
};
